import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://tv.gkmmedia.com/api';

const vodApi = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Attach auth token from localStorage on every request
vodApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('streamToken');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

class VodService {
  // Media Directory Methods
  static async getAllDirectories() {
    try {
      const response = await vodApi.get('/vod/directories');
      return response.data;
    } catch (error) {
      console.error('Error fetching directories:', error);
      throw error;
    }
  }

  static async createDirectory(directoryData) {
    try {
      const response = await vodApi.post('/vod/directories', directoryData);
      return response.data;
    } catch (error) {
      console.error('Error creating directory:', error);
      throw error;
    }
  }

  static async updateDirectory(id, updates) {
    try {
      const response = await vodApi.put(`/vod/directories/${id}`, updates);
      return response.data;
    } catch (error) {
      console.error('Error updating directory:', error);
      throw error;
    }
  }

  static async deleteDirectory(id) {
    try {
      const response = await vodApi.delete(`/vod/directories/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting directory:', error);
      throw error;
    }
  }

  // VOD Assets Methods
  static async getAllAssets() {
    try {
      const response = await vodApi.get('/vod/assets');
      return response.data;
    } catch (error) {
      console.error('Error fetching VOD assets:', error);
      throw error;
    }
  }

  static async getAssetsByDirectory(directoryId) {
    try {
      const response = await vodApi.get(`/vod/assets?directory_id=${directoryId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching directory assets:', error);
      throw error;
    }
  }

  static async uploadAsset(formData, onProgress) {
    try {
      const response = await vodApi.post('/vod/assets/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: onProgress
      });
      return response.data;
    } catch (error) {
      console.error('Error uploading asset:', error);
      throw error;
    }
  }

  static async deleteAsset(id) {
    try {
      const response = await vodApi.delete(`/vod/assets/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting asset:', error);
      throw error;
    }
  }

  // Playlist Methods
  static async getAllPlaylists() {
    try {
      const response = await vodApi.get('/vod/playlists');
      return response.data;
    } catch (error) {
      console.error('Error fetching playlists:', error);
      throw error;
    }
  }

  static async getPlaylist(id) {
    try {
      const response = await vodApi.get(`/vod/playlists/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching playlist:', error);
      throw error;
    }
  }

  static async createPlaylist(playlistData) {
    try {
      const response = await vodApi.post('/vod/playlists', playlistData);
      return response.data;
    } catch (error) {
      console.error('Error creating playlist:', error);
      throw error;
    }
  }

  static async updatePlaylist(id, updates) {
    try {
      const response = await vodApi.put(`/vod/playlists/${id}`, updates);
      return response.data;
    } catch (error) {
      console.error('Error updating playlist:', error);
      throw error;
    }
  }

  static async deletePlaylist(id) {
    try {
      const response = await vodApi.delete(`/vod/playlists/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting playlist:', error);
      throw error;
    }
  }

  // Schedule Methods
  static async getAllSchedules() {
    try {
      const response = await vodApi.get('/vod/schedules');
      return response.data;
    } catch (error) {
      console.error('Error fetching schedules:', error);
      throw error;
    }
  }

  static async createSchedule(scheduleData) {
    try {
      const response = await vodApi.post('/vod/schedules', scheduleData);
      return response.data;
    } catch (error) {
      console.error('Error creating schedule:', error);
      throw error;
    }
  }

  static async updateSchedule(id, updates) {
    try {
      const response = await vodApi.put(`/vod/schedules/${id}`, updates);
      return response.data;
    } catch (error) {
      console.error('Error updating schedule:', error);
      throw error;
    }
  }

  static async deleteSchedule(id) {
    try {
      const response = await vodApi.delete(`/vod/schedules/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting schedule:', error);
      throw error;
    }
  }

  // Automation Control
  static async toggleAutomation(scheduleId, isActive) {
    try {
      const response = await vodApi.put(`/vod/schedules/${scheduleId}`, {
        is_active: isActive
      });
      return response.data;
    } catch (error) {
      console.error('Error toggling automation:', error);
      throw error;
    }
  }

  // Get all streams for schedule assignment
  static async getAllStreams() {
    try {
      const response = await vodApi.get('/streams');
      return response.data;
    } catch (error) {
      console.error('Error fetching streams:', error);
      throw error;
    }
  }
}

export default VodService;
